<template>
  <div class="single-subportion">
    <b-button
      class="d-flex justify-content-between"
      :class="{ 'attach-pressed': btnPressed }"
    >
      <div
        class="d-flex align-items-center flex-fill"
        @click="elementSelected"
      >
        <i
          class="icon-porta primary-dark-color mr-2"
          aria-hidden="true"
        />
        <span>{{ `${sampleNumber}-${portionNumber}-${subportion.supSubportionnumber}` }}</span>
        <vtBubble
          v-if="subportion.attachmentsCount"
          :number="subportion.attachmentsCount"
          :type="false"
          :tooltip="' '+$tc('global.file',2)"
          style="margin-top: 2px"
        />
      </div>
    </b-button>
  </div>
</template>

<script>
import VtBubble from '@/components/common/VtBubble'
import subportionAttachmentService from '@/api/resources/attachment/subportionAttachmentService'
import { ATTACHMENT_ENTITY_TYPE } from '@/api/resources/attachment/attachmentResource'
import { SubportionOperationGuardMixin } from '@/api/operations/mixins/guards/subportion-operation-guard.mixin'

export default {
    name: 'SubportionTree',
    components: {
        VtBubble
    },
    mixins: [
        SubportionOperationGuardMixin
    ],
    props: {
        laboratoryId: { type: Number, required: true },
        sampleNumber: { type: String, required: true },
        portionNumber: { type: String, required: true },
        caseId: { type: Number, required: true },
        sampleId: { type: Number, required: true },
        portionId: { type: Number, required: true },
        subportion: { type: Object, required: true }
    },
    data() {
        return {
            showArrow: true,
            btnPressed: false,
            attachments: [],
            elementIcon: 'icon-porta',
            attachmentEntityType: ATTACHMENT_ENTITY_TYPE.SUBPORTION
        }
    },
    computed: {
        entityId() {
            return this.subportion.supId
        },
        entityDisplay() {
            return this.subportion.supLabel
        },
        subportionId() {
            return this.subportion.supId
        },
        userHasAttachOperation() {
            return this.$_canAttachDocumentToSubportion()
        },
        canBeAttached() {
            return this.$_canBeDocumentAttachedToSubportion(this.subportion)
        }
    },
    methods: {
        async elementSelected() {
            this.btnPressed = true
            this.attachments = await subportionAttachmentService.getAttachments(this.laboratoryId, this.caseId, this.sampleId, this.portionId, this.subportion.supId)
            this.$emit('child-selected', this)
        },
        deselect() {
            this.btnPressed = false
        }
    }
}
</script>
